<template>
  <div class="flex-col justify-start   group">
    <div class=" top-wrap">
      <div class="flex-col">
        <div class="flex-row justify-between">
          <div class="flex-row items-center group_2 channelNoPicker" @click="handleClickNo">
            <span class="font text_28">阀门：</span>
            <div class="flex-row items-center group_3 ">
              <span class="font_7 text_29 ellipsis">{{ valveName }}</span>
              <i class="iconfont icon-xiala shrink-0 image_4"></i>
            </div>
          </div>
          <div class="flex-row items-center group_2" @click="handleClickYear">
            <span class="font text_28">年份：</span>
            <div class="flex-row items-center group_3">
              <span class="font_7 text_29 ellipsis">{{ year }}年</span>
              <i class="iconfont icon-xiala shrink-0 image_4"></i>
            </div>
          </div>
        </div>
        <div class="mt-14 flex-row items-baseline">
          <span class="font_3">总时长：</span>
          <span class="text_7 ml-3">{{ totalTime ? Number(totalTime) : 0 }}</span>
          <span class="font_3 text_8 ml-3">小时</span>
        </div>
        <!-- 图表 -->
        <div id="eChartsWrap"></div>
      </div>
    </div>
    <div class="bottom-wrap">
      <div class="flex-row items-center group_21">
        <span class="font text_28">月份：</span>
        <div class="flex-row items-center group_3" :style="{ 'padding-right': '20px' }" @click="handleClickMonth">
          <div class="font_7 text_29 ellipsis">{{ month }}月</div>
          <i class="iconfont icon-xiala shrink-0 image_4"></i>
        </div>
      </div>

      <div class="mt-14 flex-col group_6">
        <van-grid>
          <van-grid-item><span :style="{ fontSize: '16px' }">序号</span> </van-grid-item>
          <van-grid-item><span :style="{ fontSize: '16px' }">日期</span> </van-grid-item>
          <van-grid-item><span :style="{ fontSize: '16px' }">阀门/程序</span> </van-grid-item>
          <van-grid-item><span :style="{ fontSize: '16px' }">时长</span> </van-grid-item>
        </van-grid>

        <div class="list-wrap">
          <van-pull-refresh class="pull-refresh" v-model="isLoading" @refresh="onRefresh">
            <van-list v-model="loading" :finished="finished" finished-text="没有更多了" :immediate-check="true" @load="onLoad">
              <van-grid v-for="(item, index) in list" :key="index">
                <van-grid-item><span :style="{ fontSize: '14px' }">{{ index + 1 }}</span> </van-grid-item>
                <van-grid-item><span :style="{ fontSize: '14px' }">{{ item.createTime }}</span> </van-grid-item>
                <van-grid-item><span :style="{ fontSize: '14px' }">{{ item.opType == 0 ? '手动' : item.opType == 1 ? '自动' :
                  '未区分' }}</span> </van-grid-item>
                <van-grid-item><span :style="{ fontSize: '14px' }">{{ item.durationSumStr }}</span>
                </van-grid-item>
              </van-grid>
            </van-list>
          </van-pull-refresh>
        </div>
      </div>
    </div>


    <van-popup v-model="showPickerNo" position="bottom" :style="{ height: '40%' }"
      @click-overlay="() => showPickerNo = false">
      <van-picker title="选择阀门" show-toolbar :columns="portsList" value-key="portName" @confirm="onConfirmNo"
        @cancel="() => showPickerNo = false" />
    </van-popup>

    <van-popup v-model="showPickerYear" position="bottom" :style="{ height: '40%' }"
      @click-overlay="() => showPickerYear = false">
      <van-picker title="选择年" show-toolbar :columns="columnsYear" @confirm="onConfirmYear"
        @cancel="() => showPickerYear = false" />
    </van-popup>

    <van-popup v-model="showPickerMonth" position="bottom" :style="{ height: '40%' }"
      @click-overlay="() => showPickerMonth = false">
      <van-picker title="选择月" show-toolbar :columns="columnsMonth" @confirm="onConfirmMonth"
        @cancel="() => showPickerMonth = false" />
    </van-popup>
  </div>
</template>

<script>
import { months } from 'moment'
import echarts from 'echarts';

export default {
  data () {
    return {
      no: localStorage.getItem('no'),
      columnsNo: [],
      columnsYear: [],
      columnsMonth: [],
      valveName: null, // 当前阀门名称
      channelNo: null, // 当前阀门通道号
      month: new Date().getMonth() + 1,
      year: new Date().getFullYear(),
      showPickerNo: false,
      showPickerYear: false,
      showPickerMonth: false,
      portsList: [],
      chart: null,
      totalTime: 0,
      page: 1,
      pages: 0,
      pageSize: 8,
      loading: false,
      finished: false,
      isFirst: true,
      isLoading: false,
      list: []
    }
  },

  async created () {
    // 解析路由参数
    const { data } = this.$route.query
    let query = {}
    if (data) { query = JSON.parse(data) }
    const { portName, channelNo } = query
    this.valveName = portName
    this.channelNo = channelNo
    const num = this.year - 2019
    const columnsYear = []
    const columnsMonth = []
    for (let i = 0; i < num; i++) {
      columnsYear.push(2020 + i)
    }

    for (let i = 1; i < 13; i++) {
      columnsMonth.push(i)
    }
    this.columnsYear = [...columnsYear]
    this.columnsMonth = [...columnsMonth]
    // 查询该设备下的所有阀门 并按名称排序
    const rtulist = await this.getRTUList(this.no)
    await this.getRTUInfo(rtulist)
  },

  async mounted () {
    this.chart = echarts.init(document.getElementById('eChartsWrap'));

    setTimeout(async () => {
      // 查询阀门与轮灌组之间的关系
      await this.getLocation()
      // 查询全年的数据
      await this.getAllData()
    }, 0)
  },

  methods: {
    async getLocation () {
      await this.$api.lgV2_getValve_rtu_relation(this.no).then(res => {
        try {
          if (res.errcode === 0) {
            const portsList = [...this.portsList]
            portsList.map(item => {
              const target = res?.data?.find(o => o.valveId === item.id)
              if (target) {
                item.channelNo = target.irriIndex + 1
              }
            })
            // 这里做RTU阀门和轮灌组的关联  拿到开关状态和开启时长
            this.portsList = [...portsList]
          } else {
          }
        } catch (e) {
          console.error("lgV2_getValve_rtu_relation err:", e);
        }
      })
    },

    // 获取RTU列表
    async getRTUList (no) {
      // 这个翻页好像是没用的
      return this.$api.getRtuList({ gatewayNo: no, }).then((res) => {
        if (res.errcode == 0) {
          if (!this.$isblank(res.data)) {
            return [...res.data]
          } else {
            return []
          }
        } else {
          this.$toast(res.errmsg)
          return []
        }
      })
    },

    async getRTUInfo (rtuList, method) {
      if (rtuList && rtuList.length) {
        let portsList = []
        if (method === 2) {
          await rtuList.map(async (item, index) => {
            item = {
              ...item,
              rtuNo: item.no,
              systemTimestamp: item.systemTimestamp,
              nameFirst: item.portName[0],
              nameSecod: item.portName.match(/\d{1,}/g)
                ? item.portName.match(/\d{1,}/g)[0]
                : '',
            }
            portsList.push(item)
          })
        } else {
          await rtuList.map(async (item, index) => {
            if (item.valves && item.valves.length) {
              item.valves.map((_item) => {
                _item = {
                  ..._item,
                  rtuNo: item.no,
                  systemTimestamp: item.systemTimestamp,
                  nameFirst: _item.portName[0],
                  nameSecod: _item.portName.match(/\d{1,}/g)
                    ? _item.portName.match(/\d{1,}/g)[0]
                    : '',
                }
                portsList.push(_item)
              })
            }
          })
        }

        let list = [...this.sortRTU(portsList)]
        if (list && list.length) {
          this.portsList = [...list]
        } else {
          this.portsList = []
          console.log("没有RTU阀门111");
        }
      } else {
        console.log("没有RTU阀门222");
      }
    },

    sortRTU (rtuList) {
      const data = [...rtuList]
      let names = []
      let group = new Set()
      // 先分组
      let groupTrunk = []

      if (data && data.length) {
        data.map((item) => {
          group.add(item.nameFirst)
        })
        group = Array.from(group).sort()
        group.map((groupId) => {
          let arr = []
          data.map((item) => {
            if (groupId === item.nameFirst) {
              arr.push(item)
            }
          })
          groupTrunk = groupTrunk.concat(this.sortGroup(arr))
        })
      }

      groupTrunk.map((item) => {
        names.push(item.portName)
      })

      return groupTrunk
    },

    sortGroup (data) {
      // 第二排序条件
      return data.sort((a, b) => {
        let _a = Number(a.nameSecod)
        let _b = Number(b.nameSecod)
        return _a - _b
      })
    },

    // 获取全年数据
    async getAllData () {
      await this.$api.getStatisticByMonth({ gatewayNo: this.no, year: this.year, channel_no: this.channelNo }).then((res) => {
        if (res.errcode != 0) return this.$toast("查询全年灌溉统计异常:" + res.errmsg)
        const data = [...res.data]
        // 需要将所有数据中的 channelNo 进行统计总时长
        // 取出所有的月份  按月分组
        const month = {}
        let totalTime = 0
        data.map(item => {
          const mon = Number(item.yearMonth.substr(4))
          if (month[mon] == null) { month[mon] = 0 }
          month[mon] += Number(this.formatToThreeDecimalPlaces(item.durationSum / 3600))  // 单位是秒
          totalTime += item.durationSum
        })
        Object.values(month).map(o => { totalTime += o })
        const xData = Object.keys(month).sort().map(o => `${o}月`)
        const yData = Object.values(month)

        console.log("xData:", xData);

        this.totalTime = Number(this.formatToThreeDecimalPlaces(totalTime / 3600))
        const options = this.setBarOptions(xData, yData)

        this.chart.setOption(options, true);
      })
    },

    // 获取某月数据
    async getValvaData () {
      this.$toast.loading('数据加载中')
      await this.$api.getStatisticByTimes({
        gatewayNo: this.no,
        year: this.year,
        channel_no: this.channelNo,
        page: this.page,
        pageSize: this.pageSize,
        month: this.month
      }).then((res) => {
        if (res.errcode === 0 && res?.data?.length) {
          res.data.map(item => {
            item.durationSumStr = this.durationDesc(item.duration)
          })
          this.list = this.list.concat(res.data);
          this.page++;
          this.isFirst = true;
          let pages = 0
          if (!pages) {
            pages = Math.floor(res.total / this.pageSize)
            if (res.total % this.pageSize !== 0) {
              pages += 1
            }
          }
          this.pages = pages
          if (this.pages === 0) { this.finished = true }

          this.isLoading = false;
          this.$toast.clear()
        } else {
          this.list = [...this.list.concat([])];
          this.finished = true
          this.isLoading = false
          this.isFirst = false;
          this.paegs = 0
          this.page = 1

          if (res.errcode != 0) return this.$toast("查询月份统计异常:" + res.errmsg)

        }
      })
    },

    durationDesc (time) {
      if (!time) return '0'
      const second = 1
      const minus = 60 * second
      const hour = 60 * minus
      if (time < minus) return `${time}秒`
      if (time < hour) return `${this.formatToThreeDecimalPlaces(time / minus)}` + '分钟'
      return this.formatToThreeDecimalPlaces(time / hour) + '小时'
    },

    formatToThreeDecimalPlaces (number) {
      // 如果输入的是 0，直接返回 0
      if (number === 0) return '0.0';
      // 将数字转换为字符串，以便后续处理
      var numStr = number.toString();
      // 如果数字是负数，提取符号部分并去除，同时标记为负数
      var isNegative = numStr.charAt(0) === '-';
      if (isNegative) {
        numStr = numStr.slice(1);
      }

      // 使用正则表达式匹配数字部分和小数点
      var match = numStr.match(/^(\d+)(?:\.(\d+))?$/);

      // 如果匹配成功
      if (match) {
        // 获取整数部分和小数部分
        var integerPart = match[1] || '0';
        var decimalPart = match[2] || '';

        // 如果小数部分长度大于 3，截取前三位有效数字
        if (decimalPart.length > 3) {
          decimalPart = decimalPart.slice(0, 3);
        } else {
          // 如果小数部分长度小于 3，用零补齐
          decimalPart = decimalPart.padEnd(3, '0');
        }

        // 将整数部分和小数部分拼接起来
        var result = integerPart + '.' + decimalPart;

        // 如果是负数，加上负号
        if (isNegative) {
          result = '-' + result;
        }

        return result;
      }

      // 如果匹配失败，返回原始输入
      return number.toString();
    },


    // 点击编号
    handleClickNo () {
      this.showPickerNo = true
    },

    // 点击年份
    handleClickYear () {
      this.showPickerYear = true
    },

    // 点击月份
    handleClickMonth () {
      this.showPickerMonth = true
    },

    // 选择编号
    onConfirmNo (e) {
      console.log("onConfirmNo:", e);
      this.valveName = e.portName
      this.channelNo = e.channelNo
      this.showPickerNo = false

      this.getAllData()
      this.onRefresh()
    },
    // 选择年
    onConfirmYear (e) {
      console.log("onConfirmYear:", e);
      this.year = e
      this.showPickerYear = false
      this.getAllData()
      this.onRefresh()
    },

    // 选择月
    onConfirmMonth (e) {
      console.log("onConfirmYear:", e, this.channelNo);
      this.month = e
      this.showPickerMonth = false
      this.list = []
      this.page = 1;
      this.pages = 0
      this.loading = false
      this.finished = false
      this.isFirst = true
      this.isLoading = true
      // this.onRefresh()
    },

    setBarOptions (xData, yData,) {
      if (xData?.length) {
        const option = {
          tooltip: {
            trigger: 'axis',
            axisPointer: { type: 'shadow' },
            formatter: function (params) {
              const { marker, value, axisValue } = params[0]
              return `<div><div>${axisValue.substring(0, 6)}</div><div>${marker} ${value} 小时</div></div>`
            }
          },
          grid: {
            top: '10%',   // 上边距占图表高度的百分比
            bottom: '15%',   // 下边距占图表高度的百分比
            left: '10%',   // 左边距占图表宽度的百分比
            right: '4%'   // 右边距占图表宽度的百分比
          },
          xAxis: {
            type: 'category',
            data: xData,
            splitLine: {
              show: false  // 不展示纵向的分隔线
            },
            axisLabel: {
              interval: 0, // 设置为 0，强制显示所有标签
            }
          },
          yAxis: [
            {
              type: 'value',
              splitLine: {
                lineStyle: {
                  // 设置横向的分隔线为虚线
                  type: 'dashed'
                }
              },
              axisLine: {
                show: false  // 隐藏 y 轴线
              },
              axisTick: {
                show: false  // 隐藏 y 轴刻度线
              },
              axisLabel: {  // 设置 y 轴标签样式
                show: true,
                textStyle: {
                  color: '#000',
                  fontSize: 12
                }
              },
            }, {
              type: 'value',
              position: 'right',
              axisLabel: {
                formatter: '{value}'
              },
              axisLine: {
                show: false  // 隐藏 y 轴线
              },
              axisTick: {
                show: false  // 隐藏 y 轴刻度线
              },
            }
          ],
          series: [
            {
              data: yData,
              type: 'bar',
              itemStyle: {
                color: '#3364DB',  // 修改柱子的颜色，这里以红色为例
                barBorderRadius: [4, 4, 0, 0]
              },
              label: {
                show: true,
                position: 'top'  // 设置标签显示位置为顶部
              },

              barWidth: '50%'
            }
          ],
        };
        return option
      }

      return {
        title: {
          text: '暂无数据',
          x: 'center',
          y: 'center',
          textStyle: {
            fontSize: 16,
            fontWeight: 'normal',
          }
        }
      }
    },

    // 下拉请求数据
    async onRefresh () {
      console.log("onRefreshonRefreshonRefreshonRefresh");
      this.list = [];
      this.page = 1;
      this.pages = 0
      this.loading = false
      this.finished = false
      this.isFirst = true
      // this.isLoading = true
      // await this.getValvaData();
      this.isLoading = false;
    },


    // 下滑请求数据
    async onLoad () {
      console.log("下滑请求数据：", this.pages, this.isFirst);
      this.loading = true;
      if (this.isFirst) {
        await this.getValvaData()
      } else if (this.pages === 0) {
        return
      } else {
        this.page <= this.pages && (await this.getValvaData());
      }
      this.loading = false;
      if (this.page > this.pages) {
        this.finished = true;
      } else {
        this.finished = false;
      }
    },
  }
}
</script>

<style lang="scss"  scoped >
@import "./../codeFunCommon.scss";

::v-deep .van-grid-item__content {
  padding: 6px 8px;
}

.ml-3 {
  margin-left: 3px;
}

.ml-31 {
  margin-left: 31px;
}

.ml-51 {
  margin-left: 51px;
}

.ml-53 {
  margin-left: 53px;
}

.group {
  height: 100%;
  overflow: hidden;
}

.top-wrap {
  height: 360px;
  padding: 15px 15px 0;
}

.bottom-wrap {
  position: absolute;
  bottom: 0;
  width: 100%;
  height: calc(100% - 364px);
  overflow-x: scroll;
  padding: 0 15px 15px;
}

.font {
  font-size: 16px;
  font-family: PingFang SC;
  line-height: 14.5px;
  color: #333333;
}

.text_3 {
  line-height: 15px;
}

.group_1 {
  padding: 8.5px 11.5px 8.5px;
  border-radius: 4px;
  height: 32px;
  border: 1px solid #2a85ff;

}

.channelNoPicker {
  width: 50%;

  .group_3 {
    max-width: 100%;
  }
}

.group_4 {
  border-radius: 4px;
  width: 110px;
  height: 32px;
  border: 1px solid #2a85ff;
  padding: 0 10px;
  justify-content: space-between;
}

.text_5 {
  margin-left: -48px;
  line-height: 15px;
}

.image_4 {

  color: #2a85ff;
  font-size: 16px;
}

.font_7 {
  font-size: 14px;
  font-family: PingFang SC;
  line-height: 13px;
  font-weight: 700;
  color: #2a85ff;
}

.text_4 {
  font-size: 14px;
  line-height: 13px;
  width: 100%;
}

.text_6 {
  font-size: 14px;
  line-height: 13px;
}

.font_3 {
  font-size: 16px;
  font-family: PingFang SC;
  line-height: 14.5px;
  color: #686868;
}

.text_7 {
  color: #2a85ff;
  font-size: 26px;
  font-family: Roboto;
  line-height: 19px;
}

.text_8 {
  line-height: 14.5px;
}

.group_21 {
  padding: 0 1.5px;
}

.text_28 {
  line-height: 15px;
}

.group_3 {
  padding: 0 10px;
  justify-content: space-between;
  border-radius: 4px;
  height: 32px;
  border-left: solid 1px #2a85ff;
  border-right: solid 1px #2a85ff;
  border-top: solid 1px #2a85ff;
  border-bottom: solid 1px #2a85ff;
}

.text_29 {
  font-size: 14px;
  line-height: 12.5px;
  width: 90%;
}

.group_6 {
  height: calc(100% - 90px);
}

.section_10 {
  padding: 13.5px 5px 13.5px 10px;
  background-color: #f8f8f8;
}

.font_8 {
  font-size: 14px;
  font-family: PingFang SC;
  line-height: 13px;
  color: #505e82;
}

.text_30 {
  margin-left: 73.5px;
  line-height: 13px;
}

.group_11 {
  margin-left: 81px;
}

.text_31 {
  line-height: 13px;
}

.group_12 {
  padding: 15.5px 4px 10.5px 19.5px;
  border-left: solid 1px #f8f8f8;
  border-right: solid 1px #f8f8f8;
  border-top: solid 1px #f8f8f8;
  border-bottom: solid 1px #f8f8f8;
}

.font_9 {
  font-size: 13px;
  font-family: PingFang SC;
  line-height: 9.5px;
  font-weight: 700;
  color: #333333;
}

.text_11 {
  line-height: 9.5px;
}

.text_33 {
  margin-left: 65px;
  line-height: 12px;
}

.text_34 {
  margin-left: 58.5px;
  line-height: 12px;
}

.header-item {
  flex: 1;

  &:last-child {
    justify-content: flex-end;
  }
}


#eChartsWrap {
  width: 100%;
  height: 300px;
}


.pull-refresh {
  height: 100%;
  font-size: 14px;
  overflow-y: scroll;
}


/deep/ .van-cell__value {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.list-wrap {
  width: 100%;
  height: 100%;
  overflow-y: scroll;
}
</style>
